import viewMounter from "~/setup/view-mounter";
import viewFinder from "~/setup/view-finder";
import { config } from "~/setup/config";
import { svgSpriteLoader } from "~/utils/svg-utils";
import "what-input";

function onDomContentLoaded() {
    const components = viewFinder();
    components.forEach(viewMounter);
}

export default function domInitializer() {
    svgSpriteLoader(config.assets.spriteUrl);
    // Mount views defined in the DOM (from sitecore)
    document.addEventListener("DOMContentLoaded", onDomContentLoaded);
}
